if (!customElements.get("language-dropdown")) {
  customElements.define(
    "language-dropdown",
    class LanguageDropdown extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
      }

      connectedCallback() {
        this.trigger = this.querySelector(".wt-lang-dropdown__trigger");
        this.panel = this.querySelector(".wt-lang-dropdown__panel");
        this.useDirectUrls = this.dataset.useDirectUrls === "true";
        this.form = this.querySelector("form");
        this.localeInput = this.form?.querySelector('[name="locale_code"]');
        this.returnInput = this.form?.querySelector('[name="return_to"]');
        this.links = this.querySelectorAll(".wt-lang-dropdown__option[href]");
        this.buttons = this.querySelectorAll(".wt-lang-dropdown__option[data-value]");

        if (!this.trigger || !this.panel) return;

        this.trigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });

        this.links.forEach((link) => {
          link.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        });

        this.buttons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.selectLanguage(button.dataset.value?.trim(), button);
          });
        });
      }

      selectLanguage(value, optionEl) {
        const current = this.dataset.currentLang;
        if (!value || value === current) {
          this.close();
          return;
        }

        if (optionEl) optionEl.classList.add("wt-lang-dropdown__option--loading");

        if (this.form && this.localeInput) {
          this.localeInput.value = value;
          if (this.returnInput) {
            this.returnInput.value =
              this.dataset.returnTo ||
              window.location.pathname + window.location.search;
          }
          this.form.submit();
          return;
        }

        this.postLocalization(value);
      }

      postLocalization(languageCode) {
        const returnTo =
          this.dataset.returnTo ||
          window.location.pathname + window.location.search;
        const action =
          this.dataset.localizationAction ||
          `${window.Shopify?.routes?.root || "/"}localization`;

        if (typeof Shopify !== "undefined" && Shopify.postLink) {
          Shopify.postLink(action, {
            method: "post",
            parameters: {
              form_type: "localization",
              utf8: "✓",
              _method: "put",
              locale_code: languageCode,
              language_code: languageCode,
              return_to: returnTo,
            },
          });
          return;
        }

        const form = document.createElement("form");
        form.method = "POST";
        form.action = action;
        form.hidden = true;

        [
          ["form_type", "localization"],
          ["utf8", "✓"],
          ["_method", "put"],
          ["locale_code", languageCode],
          ["language_code", languageCode],
          ["return_to", returnTo],
        ].forEach(([name, val]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = val;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      }

      static closeAll(except) {
        document.querySelectorAll("language-dropdown").forEach((dropdown) => {
          if (dropdown !== except) dropdown.close();
        });
      }

      open() {
        LanguageDropdown.closeAll(this);
        this.isOpen = true;
        this.panel.hidden = false;
        this.trigger.setAttribute("aria-expanded", "true");
        this.classList.add("wt-lang-dropdown--open");

        if (this.dataset.menuAccordion !== "true") {
          this.outsideClickTimer = window.setTimeout(() => {
            document.addEventListener("click", this.handleOutsideClick, true);
          }, 0);
        }
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.panel.hidden = true;
        this.trigger.setAttribute("aria-expanded", "false");
        this.classList.remove("wt-lang-dropdown--open");

        window.clearTimeout(this.outsideClickTimer);
        document.removeEventListener("click", this.handleOutsideClick, true);
      }

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      handleOutsideClick = (e) => {
        if (!this.contains(e.target)) this.close();
      };
    },
  );

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    document
      .querySelectorAll("language-dropdown.wt-lang-dropdown--open")
      .forEach((dropdown) => {
        dropdown.close();
        dropdown.querySelector(".wt-lang-dropdown__trigger")?.focus();
      });
  });
}
